import { ComponentPropsWithoutRef } from "react";
import * as S from "./SmallSpinner.styled";

type SmallSpinnerProps = ComponentPropsWithoutRef<"div">;

export const SmallSpinner = (props: SmallSpinnerProps) => (
  <S.Spinner {...props} />
);
